import { motion } from "framer-motion";
import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import confetti from "canvas-confetti";
import { apiurl } from "../config/config";
import { useSearchParams } from "react-router-dom";
import { MANAGERS, FLOOR_HEADS, FLOOR_MANAGERS } from "../json/salesTarget";
import { FaPencil } from "react-icons/fa6";

/* ================= COLOR PER 10% ================= */
const getColor = (p) => {
  if (p >= 100) return "#16a34a";
  if (p >= 90) return "#22c55e";
  if (p >= 80) return "#4ade80";
  if (p >= 70) return "#a3e635";
  if (p >= 60) return "#facc15";
  if (p >= 50) return "#fbbf24";
  if (p >= 40) return "#fb923c";
  if (p >= 30) return "#f97316";
  if (p >= 20) return "#ef4444";
  return "#dc2626";
};

/* ================= MAIN ================= */
export default function LiveBattleDisplay() {
  const [searchParams] = useSearchParams();
  const paramA = searchParams.get("A");
  const paramB = searchParams.get("B");

  const managerA = useMemo(
    () => MANAGERS.find((m) => m.key === paramA) || MANAGERS[0],
    [paramA],
  );
  const managerB = useMemo(
    () => MANAGERS.find((m) => m.key === paramB) || MANAGERS[1],
    [paramB],
  );

  //   const [orders, setOrders] = useState({ A: 0, B: 0 });
  const [orders, setOrders] = useState({
    A: 0,
    B: 0,
    GMIT: 0,
    ALTF: 0,
    TOTAL: 0,
  });

  const [managerStats, setManagerStats] = useState({
    A: {},
    B: {},
  });

const [floorStats, setFloorStats] = useState({
  GMIT: {
    totalAgents: 0,
    loginAgents: 0,
    shrinkage: 0,
    below3: 0
  },
  ALTF: {
    totalAgents: 0,
    loginAgents: 0,
    shrinkage: 0,
    below3: 0
  }
});

  const [loading, setLoading] = useState(true);
  const [openPicker, setOpenPicker] = useState(false);

  const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
  const todayDate = new Date().toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(todayDate);
  const [toDate, setToDate] = useState(todayDate);

  const fetchManagerLoginSummary = async () => {
    try {
      const res = await axios.get(`${apiurl}/utils/crm/getManagerAgentSummary`);

      if (res.data?.success) {
        const list = res.data.data.data || [];


        const calcFloorStats = (floorManagers) => {
  const managers = list.filter((m) =>
    floorManagers.some((name) =>
      m.user_name?.toLowerCase().includes(name.toLowerCase())
    )
  );

  const totalAgents = managers.reduce(
    (sum, m) => sum + Number(m.total_agents || 0),
    0
  );

  const loginAgents = managers.reduce(
    (sum, m) => sum + Number(m.today_login_count || 0),
    0
  );

  const shrinkage =
    totalAgents > 0
      ? ((totalAgents - loginAgents) / totalAgents) * 100
      : 0;

  return { totalAgents, loginAgents, shrinkage };
};

setFloorStats((prev) => ({
  GMIT: {
    ...prev.GMIT,
    ...calcFloorStats(FLOOR_MANAGERS.GMIT),
  },
  ALTF: {
    ...prev.ALTF,
    ...calcFloorStats(FLOOR_MANAGERS.ALTF),
  },
}));


        const aLogin = list.find((m) =>
          m.user_name?.toLowerCase().includes(managerA.key.toLowerCase()),
        );

        const bLogin = list.find((m) =>
          m.user_name?.toLowerCase().includes(managerB.key.toLowerCase()),
        );

        setManagerStats({
          A: {
            totalAgents: Number(aLogin?.total_agents || 0),
            loginAgents: Number(aLogin?.today_login_count || 0),
            shrinkage:
              aLogin?.total_agents > 0
                ? ((aLogin.total_agents - aLogin.today_login_count) /
                    aLogin.total_agents) *
                  100
                : 0,
            below3Orders: 0, // will update from orders API
          },

          B: {
            totalAgents: Number(bLogin?.total_agents || 0),
            loginAgents: Number(bLogin?.today_login_count || 0),
            shrinkage:
              bLogin?.total_agents > 0
                ? ((bLogin.total_agents - bLogin.today_login_count) /
                    bLogin.total_agents) *
                  100
                : 0,
            below3Orders: 0,
          },
        });
      }
    } catch (err) {
      console.error("Login Summary Error:", err);
    }
  };

  useEffect(() => {
    fetchManagerLoginSummary();

    const interval = setInterval(() => {
      fetchManagerLoginSummary();
    }, 600000); // every 10 minutes

    return () => clearInterval(interval);
  }, []);

  /* ================= FETCH (30s) ================= */
  useEffect(() => {
    const fetchSales = async () => {
      try {
        const res = await axios.get(`${apiurl}/utils/crm/realTimeOrderData2`, {
          headers: {
            token: "ad2355a9d54335e27e2c3a3ed5b6e381",
            "Content-Type": "application/json",
          },
          params: {
            from_date: fromDate || today,
            to_date: toDate || today,
          },
        });

        const list = res?.data?.data?.result?.data?.managers || [];

        const managerList = res.data?.data?.result?.data?.managers || [];
        const calcFloorBelow3 = (floorManagers) => {
  const managers = managerList.filter((m) =>
    floorManagers.some((name) =>
      m.o_manager_name?.toLowerCase().includes(name.toLowerCase())
    )
  );

  return managers.reduce(
    (sum, m) => sum + Number(m.agent_count_below_3 || 0),
    0
  );
};

setFloorStats((prev) => ({
  GMIT: {
    ...prev.GMIT,
    below3: calcFloorBelow3(FLOOR_MANAGERS.GMIT),
  },
  ALTF: {
    ...prev.ALTF,
    below3: calcFloorBelow3(FLOOR_MANAGERS.ALTF),
  },
}));


        const managerMap = {};

        managerList.forEach((m) => {
          managerMap[m.o_manager_name] = Number(m.totalOrders || 0);
        });

        const a = list.find((m) => m.o_manager_name === managerA.key);
        const b = list.find((m) => m.o_manager_name === managerB.key);

        // setManagerStats({
        //   A: {
        //     totalAgents: a?.total_agents || 0,
        //     loginAgents: a?.today_login_count || 0,
        //     below3Orders: a?.agent_count_below_3 || 0,
        //     shrinkage:
        //       a?.total_agents > 0
        //         ? ((a.total_agents - a.today_login_count) / a.total_agents) *
        //           100
        //         : 0,
        //   },
        //   B: {
        //     totalAgents: b?.total_agents || 0,
        //     loginAgents: b?.today_login_count || 0,
        //     below3Orders: b?.agent_count_below_3 || 0,
        //     shrinkage:
        //       b?.total_agents > 0
        //         ? ((b.total_agents - b.today_login_count) / b.total_agents) *
        //           100
        //         : 0,
        //   },
        // });

        setManagerStats((prev) => ({
          A: {
            ...prev.A,
            below3Orders: Number(a?.agent_count_below_5 || 0),
          },
          B: {
            ...prev.B,
            below3Orders: Number(b?.agent_count_below_5 || 0),
          },
        }));
        // setManagerStats((prev) => ({
        //   A: {
        //     ...prev.A,
        //     below3Orders: Number(a?.agent_count_below_3 || 0),
        //   },
        //   B: {
        //     ...prev.B,
        //     below3Orders: Number(b?.agent_count_below_3 || 0),
        //   },
        // }));
        setOrders({
          A: Number(a?.totalOrders || 0),
          B: Number(b?.totalOrders || 0),
        });

        /* FIND MANAGER A & B */
        const aOrders = managerMap[managerA.key] || 0;
        const bOrders = managerMap[managerB.key] || 0;

        /* CALCULATE FLOOR TOTALS */
        const floorTotals = {};

        Object.keys(FLOOR_MANAGERS).forEach((floor) => {
          floorTotals[floor] = FLOOR_MANAGERS[floor].reduce(
            (sum, managerKey) => {
              return sum + (managerMap[managerKey] || 0);
            },
            0,
          );
        });

        /* SAVE EVERYTHING */
        setOrders({
          A: aOrders,
          B: bOrders,
          ...floorTotals,
          TOTAL: Number(res.data?.data?.result?.data?.total?.totalOrders || 0),
        });
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    fetchSales();
    const t = setInterval(fetchSales, 30000);
    return () => clearInterval(t);
  }, [managerA.key, managerB.key, fromDate, toDate]);

  /* ================= CONFETTI ================= */
  useEffect(() => {
    if (!loading) {
      confetti({ particleCount: 100, spread: 80, origin: { y: 0.6 } });
    }
  }, [orders, loading]);

  const achA = Math.round((orders.A / managerA.target) * 100);
  const achB = Math.round((orders.B / managerB.target) * 100);

  const winner =
    orders.A === orders.B ? "DRAW" : orders.A > orders.B ? "A" : "B";

  const leadText =
    winner === "DRAW"
      ? "Draw match"
      : winner === "A"
        ? `${managerA.name} leads by ${orders.A - orders.B} orders`
        : `${managerB.name} leads by ${orders.B - orders.A} orders`;

  const calcAchievement = (value, target) =>
    Math.round((value / Number(target)) * 100);

  const gmitAch = calcAchievement(orders.GMIT, FLOOR_HEADS[0].target);
  const altfAch = calcAchievement(orders.ALTF, FLOOR_HEADS[1].target);

  const floorWinner =
    gmitAch === altfAch ? "DRAW" : gmitAch > altfAch ? "GMIT" : "ALTF";

  // Trigger confetti every update
  useEffect(() => {
    if (!loading) {
      confetti({
        particleCount: 150,
        spread: 100,
        origin: { y: 0.6 },
      });
    }
  }, [orders]); // Runs every time orders change

  useEffect(() => {
    if (!loading && (gmitAch >= 100 || altfAch >= 100)) {
      confetti({
        particleCount: 180,
        spread: 120,
        origin: { y: 0.6 },
      });
    }
  }, [gmitAch, altfAch]);

  const totalOrders = orders.TOTAL;
  const totalFloorOrders = orders.GMIT + orders.ALTF;







const [teamData, setTeamData] = useState([]);

const fetchPerformance = async () => {
  try {

    const baseParams = {
      from_date: fromDate || today,
      to_date: toDate || today,
      agent_ids: "",
      manager_ids: ""
    };

    const [dcRes, ppRes] = await Promise.all([
      axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
        params: { ...baseParams, tl_ids: "Superdc" }
      }),
      axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
        params: { ...baseParams, tl_ids: "Super_Paachan_Pro" }
      })
    ]);

    const dcOrders =
      dcRes?.data?.data?.result?.data?.total?.totalOrders || 0;

    const ppOrders =
      ppRes?.data?.data?.result?.data?.total?.totalOrders || 0;

    const teams = [
      {
        team_name: "SUPER_DC_TEAM",
        orders: dcOrders,
        target: 240,
        image: "/images/superDCTeam.png"
      },
      {
        team_name: "SUPER_PP_TEAM",
        orders: ppOrders,
        target: 240,
        image: "/images/superPPTeam.png"
      }
    ];

    setTeamData(teams);

  } catch (error) {
    console.error("Team API Error:", error);
  }
};
useEffect(() => {

  fetchPerformance();

  const interval = setInterval(fetchPerformance, 50000);

  return () => clearInterval(interval);

}, [fromDate, toDate]);



  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-4xl font-bold">
        Loading…
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6 lg:p-10 xl:p-16">
      {/* HEADER */}
      <div className="mb-10">
        {/* DATE FILTER */}
        <div
          className="mx-auto mb-8 flex w-full max-w-7xl flex-col items-stretch justify-center gap-4 rounded-2xl bg-white p-4 shadow-md md:flex-row md:items-center md:justify-between"
        >
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div className="flex flex-col">
              <label className="text-xs text-gray-500 mb-1">From Date</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="w-full border px-3 py-2 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-black"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-xs text-gray-500 mb-1">To Date</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="w-full border px-3 py-2 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-black"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3 sm:flex sm:justify-end">
            <button
              onClick={() => {
                setFromDate(todayDate);
                setToDate(todayDate);
              }}
              className="px-4 py-2 bg-gray-200 rounded-xl text-sm hover:bg-gray-300 transition whitespace-nowrap"
            >
              Today
            </button>

            <button
              onClick={() => {
                const d = new Date();
                d.setDate(d.getDate() - 7);
                setFromDate(d.toISOString().split("T")[0]);
                setToDate(todayDate);
              }}
              className="px-4 py-2 bg-black text-white rounded-xl text-sm hover:scale-105 transition whitespace-nowrap"
            >
              Last 7 Days
            </button>
          </div>
        </div>

        {/* Top Row */}
        <div
          className="mx-auto mb-4 flex w-full max-w-7xl flex-col gap-4 md:mb-8 md:flex-row md:items-center md:justify-between"
        >
          {/* TITLE SECTION */}
          <div className="text-center md:text-left">
            <h1 className="text-2xl sm:text-3xl md:text-5xl font-extrabold tracking-tight">
              Performance Battle
            </h1>

            <p className="text-sm sm:text-base text-gray-500 mt-1">
              Live manager comparison dashboard
            </p>
          </div>

          {/* ACTION BUTTON */}
          <button
            onClick={() => setOpenPicker(true)}
            className="flex items-center justify-center gap-2
               bg-gradient-to-r from-black to-gray-800
               text-white px-5 py-2.5
               rounded-xl text-sm sm:text-base md:text-lg
               shadow-lg hover:shadow-xl
               hover:scale-105 active:scale-95
               transition-all duration-200"
          >
            <FaPencil className="text-sm md:text-base" />
            Change Managers
          </button>
        </div>

        {/* Battle Row */}
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-6 md:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)]">
          {/* Manager A */}
          <div className="text-right hidden md:block">
            <p className="text-sm uppercase tracking-widest text-gray-500">
              Manager A
            </p>
            <h2 className="text-2xl lg:text-3xl font-extrabold break-words">{managerA.name}</h2>
          </div>

          {/* Live Lead Banner */}
          <div className="flex justify-center">
            <LiveLeadBanner
              text={leadText}
              winner={winner}
              diff={Math.abs(orders.A - orders.B)}
            />
          </div>

          {/* Manager B */}
          <div className="text-left hidden md:block">
            <p className="text-sm uppercase tracking-widest text-gray-500">
              Manager B
            </p>
            <h2 className="text-2xl lg:text-3xl font-extrabold break-words">{managerB.name}</h2>
          </div>
        </div>
      </div>

      {/* CARDS */}
      {/* <div className="grid grid-cols-2 md:grid-cols-[45%_10%_45%] items-center"> */}
      <div className="mx-auto grid w-full max-w-7xl grid-cols-2 items-stretch gap-3 sm:gap-4 lg:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] lg:gap-6 xl:gap-8">
        <ManagerCard
          manager={managerA}
          value={orders.A}
          achievement={achA}
          stats={managerStats.A}
          status={winner === "DRAW" ? "DRAW" : winner === "A" ? "WIN" : "LOSE"}
        />

        <div className="hidden self-center text-center text-5xl font-extrabold text-gray-300 lg:block xl:text-8xl">
          VS
        </div>

        <ManagerCard
          manager={managerB}
          value={orders.B}
          achievement={achB}
          stats={managerStats.B}
          status={winner === "DRAW" ? "DRAW" : winner === "B" ? "WIN" : "LOSE"}
        />
      </div>
      {/* PICKER */}
      {openPicker && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 px-4">
          <div className="relative bg-white rounded-3xl p-6 md:p-8 w-full max-w-md">
            {/* CLOSE BUTTON (TOP RIGHT) */}
            <button
              onClick={() => setOpenPicker(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl font-bold"
            >
              ✕
            </button>

            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center">
              Choose Managers
            </h2>

            {/* SELECT A */}
            <select id="A" className="w-full border p-3 mb-4 rounded-xl">
              {MANAGERS.map((m) => (
                <option key={m.key} value={m.key}>
                  {m.name}
                </option>
              ))}
            </select>

            {/* SELECT B */}
            <select id="B" className="w-full border p-3 mb-6 rounded-xl">
              {MANAGERS.map((m) => (
                <option key={m.key} value={m.key}>
                  {m.name}
                </option>
              ))}
            </select>

            {/* START BUTTON */}
            <button
              onClick={() => {
                const A = document.getElementById("A").value;
                const B = document.getElementById("B").value;
                window.location.href = `/screen/live-battle?A=${A}&B=${B}`;
              }}
              className="w-full bg-green-600 hover:bg-green-700 transition text-white py-3 rounded-xl text-lg font-semibold"
            >
              Start Battle 🚀
            </button>

            {/* CANCEL BUTTON */}
            <button
              onClick={() => setOpenPicker(false)}
              className="w-full mt-3 bg-gray-200 hover:bg-gray-300 transition py-3 rounded-xl font-medium"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      <div className="w-full max-w-7xl mx-auto mt-6">
        <div
          className="grid 
                  grid-cols-1 
                  md:grid-cols-2
                  items-stretch
                  gap-4 lg:gap-6"
        >
          {/* GMIT */}
          {/* <FloorCard
            floor={FLOOR_HEADS[0]}
            value={orders.GMIT}
            achievement={gmitAch}
            isWinner={winner === "GMIT"}
            isLoser={winner === "ALTF"}
            isDraw={winner === "DRAW"}
          /> */}

          {/* VS Section */}
          {/* <div className="flex justify-center items-center">
      <div className="
          w-20 h-20 md:w-40 md:h-40
          rounded-full
          bg-gradient-to-br from-gray-800 to-black
          text-white
          flex items-center justify-center
          font-extrabold
          text-2xl md:text-6xl
          shadow-2xl
          border-4 border-white
          animate-pulse
      ">
        VS
      </div>
    </div> */}

          {/* ALTF */}
          {/* <FloorCard
            floor={FLOOR_HEADS[1]}
            value={orders.ALTF}
            achievement={altfAch}
            isWinner={winner === "ALTF"}
            isLoser={winner === "GMIT"}
            isDraw={winner === "DRAW"}
          /> */}

          <FloorCard
            floor={FLOOR_HEADS[0]}
            value={orders.GMIT}
            achievement={gmitAch}
              stats={floorStats.GMIT}
            isWinner={floorWinner === "GMIT"}
            isLoser={floorWinner === "ALTF"}
            isDraw={floorWinner === "DRAW"}
          />

          <FloorCard
            floor={FLOOR_HEADS[1]}
            value={orders.ALTF}
            achievement={altfAch}
            stats={floorStats.ALTF}
            isWinner={floorWinner === "ALTF"}
            isLoser={floorWinner === "GMIT"}
            isDraw={floorWinner === "DRAW"}
          />
        </div>
      </div>

      {/* KPI SUMMARY */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-6 p-3 rounded-xl bg-white shadow-lg w-full max-w-7xl mx-auto">
        <SummaryCard
          title="Total Orders"
          value={totalOrders}
          icon="📦"
          color="from-blue-500 to-indigo-600"
        />

        <SummaryCard
          title="Manager Battle"
          value={orders.A + orders.B}
          icon="⚔️"
          color="from-purple-500 to-pink-600"
        />

        <SummaryCard
          title="Floor Orders"
          value={totalFloorOrders}
          icon="🏢"
          color="from-green-500 to-emerald-600"
        />
      </div>
      <TeamWiseCard data={teamData} />
    </div>
  );
}

/* ================= CARD ================= */
function ManagerCard({ manager, value, achievement, stats, status }) {
  const color = getColor(achievement);

  return (
    <motion.div
      animate={{ scale: status === "WIN" ? [1, 1.05, 1] : 1 }}
      transition={{ duration: 1, repeat: status === "WIN" ? Infinity : 0 }}
      className="relative bg-white rounded-3xl shadow-2xl 
                 p-3 sm:p-4 lg:p-6 pt-11 sm:pt-12 lg:pt-14 min-w-0"
    >
      {/* STATUS STRIP */}
      {status !== "DRAW" && (
        <div
          className={`absolute top-0 left-0 right-0 text-center 
                      py-2 text-xs md:text-sm text-white font-bold 
                      rounded-t-3xl ${
                        status === "WIN" ? "bg-green-600" : "bg-red-600"
                      }`}
        >
          {status === "WIN" ? "🏆 WINNER" : "😞 LOSER"}
        </div>
      )}

      {status === "DRAW" && (
        <div
          className="absolute top-0 left-0 right-0 text-center 
                        py-2 text-xs md:text-sm bg-gray-700 
                        text-white font-bold rounded-t-3xl"
        >
          🤝 DRAW
        </div>
      )}

      {/* IMAGE + NAME */}
      <div className="flex flex-col items-center gap-3 lg:gap-4">
        <img
          src={manager.photo}
          alt={manager.name}
          className="w-24 h-24 sm:w-28 sm:h-28 md:w-36 md:h-36 lg:w-52 lg:h-52 xl:w-64 xl:h-64
                     rounded-full border-4 object-cover"
          style={{ borderColor: color }}
        />

        <h2
          className="text-base sm:text-lg lg:text-2xl xl:text-3xl 
                       font-bold text-center leading-tight"
        >
          {manager.name}
        </h2>
      </div>

      {/* NUMBERS */}
      <div className="mt-4 lg:mt-6 text-center">
        <div
          className="text-xl sm:text-2xl lg:text-4xl xl:text-5xl 
                        font-extrabold leading-tight"
        >
          {value} <span className="text-gray-400">/</span> {manager.target}
        </div>

        <p
          className="text-sm sm:text-base lg:text-lg xl:text-xl 
                      text-gray-600 mt-1"
        >
          {achievement}% achieved
        </p>
      </div>

      {/* PROGRESS BAR */}
      <div
        className="mt-4 lg:mt-6 h-3 lg:h-5 bg-gray-200 
                      rounded-full overflow-hidden"
      >
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${Math.min(achievement, 100)}%` }}
          transition={{ duration: 0.6 }}
          className="h-full"
          style={{ background: color }}
        />
      </div>
      <div className="grid grid-cols-2 xl:grid-cols-4 gap-1 mt-3 text-center">
        <div className="bg-gray-50 border rounded-md py-1">
          <p className="text-[9px] text-gray-500 uppercase leading-none">
            Agents
          </p>
          <p className="text-sm lg:text-lg font-semibold text-gray-700 leading-none">
            {stats?.totalAgents || 0}
          </p>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-md py-1">
          <p className="text-[9px] text-green-600 uppercase leading-none">
            Active
          </p>
          <p className="text-sm lg:text-lg font-semibold text-green-700 leading-none">
            {stats?.loginAgents || 0}
          </p>
        </div>

        <div className="bg-red-50 border border-red-200 rounded-md py-1">
          <p className="text-[9px] text-red-500 uppercase leading-none">
            Shrink
          </p>
          <p className="text-sm lg:text-lg font-semibold text-red-700 leading-none">
            {stats?.shrinkage?.toFixed(1) || 0}%
          </p>
        </div>

        <div className="bg-orange-50 border border-orange-200 rounded-md py-1">
          <p className="text-[9px] text-orange-500 uppercase leading-none">
            Below5
          </p>
          <p className="text-sm lg:text-lg font-semibold text-orange-700 leading-none">
            {stats?.below3Orders || 0}
          </p>
        </div>
      </div>
    </motion.div>
  );
}

function LiveLeadBanner({ text, winner, diff }) {
  if (!winner) return null;

  if (winner === "DRAW") {
    return (
      <motion.div
        initial={{ opacity: 0, y: -15 }}
        animate={{ opacity: 1, y: 0 }}
        className="mt-2 md:mt-6 px-5 sm:px-6 py-3 rounded-2xl 
                   bg-gray-800 text-white 
                   inline-flex max-w-full items-center justify-center gap-3 
                   text-base md:text-xl font-bold shadow-lg text-center"
      >
        🤝 Match is Tied
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="mt-1 md:mt-6 relative overflow-hidden 
                 rounded-2xl px-5 sm:px-6 md:px-8 py-3 sm:py-4 
                 bg-white border-2 border-green-500 
                 shadow-xl inline-flex max-w-full items-center gap-3 sm:gap-4"
    >
      {/* Left Accent Bar */}
      <div className="absolute left-0 top-0 bottom-0 w-2 bg-green-500 rounded-l-2xl" />

      {/* Trophy Icon */}
      <motion.span
        animate={{ scale: [1, 1.15, 1] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
        className="text-2xl md:text-3xl shrink-0"
      >
        🏆
      </motion.span>

      {/* Text */}
      <div className="flex min-w-0 flex-col">
        <span className="text-base md:text-lg font-semibold text-gray-700">
          Leading Now
        </span>

        <span className="text-sm md:text-xl xl:text-2xl font-extrabold text-green-600 tracking-wide break-words">
          {text}
        </span>
      </div>

      {/* Lead Difference */}
      <motion.div
        key={diff}
        initial={{ scale: 1.4 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 300 }}
        className="ml-auto shrink-0 bg-green-100 text-green-700 
                   px-3 sm:px-4 py-2 rounded-xl 
                   text-base md:text-xl font-black"
      >
        +{diff}
      </motion.div>
    </motion.div>
  );
}

function FloorCard({ floor, value, achievement, stats, isWinner, isLoser, isDraw }) {
  console.log(
    "Rendering FloorCard:",
    floor.key,
    "Value:",
    value,
    "Achievement:",
    achievement,
    "Stats:",
    stats,
    "Winner:",
    isWinner,
    "Loser:",
    isLoser,
    "Draw:",
    isDraw,
  );

  const target = Number(floor.target);
  const remaining = Math.max(target - value, 0);

  const getProgressColor = (percent) => {
    if (percent >= 100) return "#22c55e"; // green
    if (percent >= 90) return "#4ade80";
    if (percent >= 80) return "#84cc16";
    if (percent >= 70) return "#facc15";
    if (percent >= 60) return "#fbbf24";
    if (percent >= 50) return "#fb923c";
    if (percent >= 40) return "#f97316";
    if (percent >= 30) return "#ef4444";
    if (percent >= 20) return "#dc2626";
    return "#b91c1c"; // deep red
  };

  const progressColor = getProgressColor(achievement);

  const status =
    achievement >= 100
      ? {
          label: "TARGET ACHIEVED",
          color: "bg-green-600",
          bar: "#22c55e",
          border: "border-green-600",
        }
      : achievement >= 90
        ? {
            label: "EXCELLENT",
            color: "bg-green-400",
            bar: "#4ade80",
            border: "border-green-400",
          }
        : achievement >= 80
          ? {
              label: "VERY GOOD",
              color: "bg-lime-500",
              bar: "#84cc16",
              border: "border-lime-500",
            }
          : achievement >= 70
            ? {
                label: "ON TRACK",
                color: "bg-yellow-400",
                bar: "#facc15",
                border: "border-yellow-400",
              }
            : achievement >= 60
              ? {
                  label: "NEEDS PUSH",
                  color: "bg-amber-400",
                  bar: "#fbbf24",
                  border: "border-amber-400",
                }
              : achievement >= 50
                ? {
                    label: "BELOW AVERAGE",
                    color: "bg-orange-400",
                    bar: "#fb923c",
                    border: "border-orange-400",
                  }
                : achievement >= 40
                  ? {
                      label: "WARNING",
                      color: "bg-orange-500",
                      bar: "#f97316",
                      border: "border-orange-500",
                    }
                  : achievement >= 30
                    ? {
                        label: "CRITICAL",
                        color: "bg-red-500",
                        bar: "#ef4444",
                        border: "border-red-500",
                      }
                    : achievement >= 20
                      ? {
                          label: "VERY CRITICAL",
                          color: "bg-red-600",
                          bar: "#dc2626",
                          border: "border-red-600",
                        }
                      : {
                          label: "ALERT",
                          color: "bg-red-700",
                          bar: "#b91c1c",
                          border: "border-red-700",
                        };

  return (
    <motion.div
      animate={{
        scale: isWinner ? [1, 1.05, 1] : 1,
        boxShadow: isWinner
          ? [
              "0 0 0px rgba(0,0,0,0)",
              "0 0 25px rgba(34,197,94,0.7)",
              "0 0 0px rgba(0,0,0,0)",
            ]
          : "none",
      }}
      transition={{ duration: 1.5, repeat: isWinner ? Infinity : 0 }}
      className={`
        relative
        rounded-2xl
        p-3 sm:p-4
        bg-white
        shadow-lg
        border-2
        overflow-hidden
        min-w-0
        ${status.border}
        ${isLoser ? "opacity-80 bg-red-50" : ""}
      `}
    >
      {/* TOP PROGRESS STRIP */}
      <div
        className="absolute top-0 left-0 right-0 h-1.5"
        style={{ backgroundColor: progressColor }}
      />

      {/* WINNER BADGE */}
      {isWinner && (
        <div className="absolute top-2 left-1 bg-green-600 text-white text-xs px-3 py-1 rounded-full shadow-lg font-bold">
          🏆 WINNER
        </div>
      )}

      {/* LOSER BADGE */}
      {isLoser && (
        <div className="absolute top-2 left-1 bg-red-600 text-white text-xs px-3 py-1 rounded-full shadow-lg font-bold">
          LOSER
        </div>
      )}

      {/* DRAW BADGE */}
      {isDraw && (
        <div className="absolute top-2 left-1 bg-gray-700 text-white text-xs px-3 py-1 rounded-full shadow-lg font-bold">
          DRAW
        </div>
      )}

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
        {/* IMAGE */}
        <img
          src={floor.photo}
          alt={floor.name}
          className="w-16 h-16 md:w-24 md:h-24 xl:w-32 xl:h-32 rounded-full border-4 object-cover self-center shrink-0"
          style={{ borderColor: progressColor }}
        />

        {/* CONTENT */}
        <div className="min-w-0 flex-1">
          <h2 className="text-base md:text-xl xl:text-2xl font-bold break-words text-center sm:text-left">{floor.name}</h2>
          {/* <p className="text-xs md:text-lg opacity-70">{floor.key}</p> */}

          <div className="mt-2 text-lg md:text-3xl xl:text-4xl font-extrabold text-center sm:text-left">
            {value ?? 0}
            <span className="opacity-50 text-sm md:text-xl"> / {target}</span>
          </div>

          <p className="text-xs md:text-base opacity-60 text-center sm:text-left">
            {remaining > 0 ? `${remaining} left` : "Target Done 🎉"}
          </p>

          {/* PROGRESS */}
          <div className="mt-2">
            <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: `${Math.min(achievement, 100)}%` }}
                transition={{ duration: 0.6 }}
                className="h-full"
                style={{ backgroundColor: progressColor }}
              />
            </div>

            <div className="flex flex-col gap-1 sm:flex-row sm:justify-between mt-2 text-xs md:text-sm text-gray-600">
              <span>{achievement}% achieved</span>
              <span className="font-semibold">{status.label}</span>
            </div>
          </div>
          <div className="grid grid-cols-2 xl:grid-cols-4 gap-1 mt-3 text-center">

  <div className="bg-gray-50 border rounded-md py-1">
    <p className="text-[9px] text-gray-500 uppercase">Agents</p>
    <p className="text-sm font-semibold">{stats?.totalAgents || 0}</p>
  </div>

  <div className="bg-green-50 border border-green-200 rounded-md py-1">
    <p className="text-[9px] text-green-600 uppercase">Active</p>
    <p className="text-sm font-semibold text-green-700">
      {stats?.loginAgents || 0}
    </p>
  </div>

  <div className="bg-red-50 border border-red-200 rounded-md py-1">
    <p className="text-[9px] text-red-500 uppercase">Shrink</p>
    <p className="text-sm font-semibold text-red-700">
      {stats?.shrinkage?.toFixed(1) || 0}%
    </p>
  </div>

  <div className="bg-orange-50 border border-orange-200 rounded-md py-1">
    <p className="text-[9px] text-orange-500 uppercase">Below5</p>
    <p className="text-sm font-semibold text-orange-700">
      {stats?.below3 || 0}
    </p>
  </div>

</div>
        </div>
      </div>

      {/* CORNER ICON */}
      <div className="absolute top-2 right-2 text-lg">
        {isWinner && "👑"}
        {isLoser && "😞"}
        {isDraw && "🤝"}
      </div>
    </motion.div>
  );
}

function SummaryCard({ title, value, icon, color }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ scale: 1.05 }}
      className={`relative overflow-hidden rounded-2xl p-4 md:p-6 text-white shadow-xl bg-gradient-to-r ${color}`}
    >
      {/* ICON */}
      <div className="text-3xl md:text-4xl absolute top-4 right-4 opacity-80">
        {icon}
      </div>

      {/* TITLE */}
      <p className="text-xs md:text-sm uppercase tracking-wider opacity-90">
        {title}
      </p>

      {/* VALUE */}
      <motion.h3
        key={value}
        initial={{ scale: 1.3 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 300 }}
        className="text-2xl md:text-4xl font-extrabold mt-1"
      >
        {value}
      </motion.h3>

      {/* LIVE PULSE */}
      <motion.div
        animate={{ opacity: [1, 0.3, 1] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
        className="absolute bottom-2 right-4 text-xs font-bold"
      >
        LIVE
      </motion.div>
    </motion.div>
  );
}




function TeamWiseCard({ data }) {
  const winner =
    data?.length > 0
      ? data.reduce((prev, curr) => (prev.orders > curr.orders ? prev : curr))
      : null;

  // Confetti for target achievement
  useEffect(() => {
    if (winner && winner.orders >= winner.target) {
      confetti({
        particleCount: 150,
        spread: 80,
        origin: { y: 0.6 },
        colors: ["#22c55e", "#3b82f6", "#facc15"], // modern subtle colors
      });
    }
  }, [winner]);

  return (
    <div className="relative w-full max-w-7xl mx-auto mt-6">
      {/* Title */}
      {/* <h1 className="text-4xl lg:text-5xl font-extrabold text-center mb-10 text-white tracking-wide drop-shadow-md">
        ⚔️ Sales Battle Arena
      </h1> */}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6">

        {data.map((team) => {
          const pct = team.target ? Math.round((team.orders / team.target) * 100) : 0;
          const isWinner = winner?.team_name === team.team_name;

          return (
            <motion.div
              key={team.team_name}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              whileHover={{ scale: 1.02 }}
              className="relative rounded-xl overflow-hidden shadow-md border border-gray-300 bg-white backdrop-blur-sm"
            >
              {/* Team Image */}
              <div className="relative h-52 sm:h-60 lg:h-72">
                <img
                  src={team.image}
                  alt={team.team_name}
                  className="w-full h-full object-cover rounded-t-xl"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent rounded-t-xl" />

                {/* Winner crown */}
                {isWinner && (
                  <div className="absolute top-2 right-2 text-2xl lg:text-3xl">👑</div>
                )}

                {/* Target hit badge */}
                {pct >= 100 && (
                  <div className="absolute top-2 left-2 bg-green-500 text-white px-3 py-1 rounded font-semibold text-sm">
                    🎯 Target Hit
                  </div>
                )}

                {/* Team name */}
                <div className="absolute bottom-2 left-3 right-3">
                  <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-white drop-shadow-md break-words">
                    {team.team_name}
                  </h2>
                </div>
              </div>

              {/* Stats */}
              <div className="p-4 lg:p-5">
                <div className="grid grid-cols-3 text-center gap-3">
                  <div>
                    <p className="text-gray-400 uppercase text-xs">Orders</p>
                    <p className="text-lg lg:text-xl font-bold text-blue-600">{team.orders}</p>
                  </div>
                  <div>
                    <p className="text-gray-400 uppercase text-xs">Target</p>
                    <p className="text-lg lg:text-xl font-bold text-red-600">{team.target}</p>
                  </div>
                  <div>
                    <p className="text-gray-400 uppercase text-xs">Achieved</p>
                    <p className="text-lg lg:text-xl font-bold text-green-600">{pct}%</p>
                  </div>
                </div>

                {/* Progress Bar */}
                <div className="mt-3 h-3 w-full bg-gray-700 rounded-full overflow-hidden">
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${pct}%` }}
                    transition={{ duration: 1.2 }}
                    className={`h-full ${pct >= 100 ? "bg-green-400" : "bg-blue-500"}`}
                  />
                </div>

                {/* Hot streak */}
                {pct > 70 && pct < 100 && (
                  <div className="mt-2 text-center text-yellow-400 font-semibold text-sm lg:text-base animate-pulse">
                    🔥 Hot Streak
                  </div>
                )}
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
